<template>
  <div class="nav-margin report-page">
    <navigation></navigation>
    <div class="dashboard">
      <div class="dashboard-head">
        <div>
          <router-link to="/jobs" class="date-eyebrow back-link">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6" /></svg>
            Jobs
          </router-link>
          <h1 class="page-title">Jobs report</h1>
        </div>
        <div class="dashboard-controls">
          <period-filter :value="period" @input="onPeriodChange" />
        </div>
      </div>
      <jobs-dashboard :period="period" :premium="isPremiumAccount" />
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import navigation from "../components/global/navigation.vue";
import periodFilter from "../components/overview/period-filter.vue";
import jobsDashboard from "../components/overview/jobs-dashboard.vue";

const PERIOD_STORAGE_KEY = "jobs-report::period";
const PRESET_RANGES = {
  "7d": { amount: 7, unit: "days" },
  "30d": { amount: 30, unit: "days" },
  "90d": { amount: 90, unit: "days" },
  "12m": { amount: 12, unit: "months" },
};

export default {
  name: "JobReport",
  components: { navigation, periodFilter, jobsDashboard },
  data() {
    let preset = "30d";
    try {
      const stored = window.localStorage.getItem(PERIOD_STORAGE_KEY);
      if (stored && (PRESET_RANGES[stored] || stored === "all")) preset = stored;
    } catch (e) { /* localStorage unavailable */ }
    const sku = _.get(this.$A, "Auth.account.subscriptionState.sku", "");
    return {
      isPremiumAccount: sku.includes("enterprise") || sku.includes("premium"),
      period: { preset, ...this.rangeForPreset(preset) },
    };
  },
  methods: {
    rangeForPreset(key) {
      const range = PRESET_RANGES[key];
      if (!range) return { startDate: null, endDate: null };
      return {
        startDate: moment().endOf("day").subtract(range.amount, range.unit).startOf("day").toISOString(),
        endDate: moment().endOf("day").toISOString(),
      };
    },
    onPeriodChange(period) {
      this.period = period;
      try {
        if (period.preset !== "custom") window.localStorage.setItem(PERIOD_STORAGE_KEY, period.preset);
      } catch (e) { /* ignore */ }
    },
  },
};
</script>

<style scoped>
.report-page {
  min-height: 100vh;
  background: #f4f5f7;
}
.dashboard {
  display: flex;
  flex-direction: column;
  gap: 24px;
  max-width: 1320px;
  margin: 0 auto;
  padding: 24px;
}
.dashboard-head {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}
.date-eyebrow {
  font-size: 11px;
  font-weight: 700;
  color: #6b7280;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  margin-bottom: 6px;
}
.back-link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  text-decoration: none;
}
.back-link:hover {
  color: #019256;
  text-decoration: none;
}
.page-title {
  font-size: 28px;
  line-height: 34px;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: #111827;
  margin: 0;
}
.dashboard-controls {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
@media (max-width: 575px) {
  .dashboard {
    padding: 16px;
    gap: 16px;
  }
  .page-title {
    font-size: 22px;
    line-height: 28px;
  }
}
</style>
